import { observable } from "mobx"
import Constants from "../../common/constants/Constants"
import HttpStatusCode from "../../common/constants/HttpErrorCode"
import { getRequest } from "../../common/helpers/RequestHelper"
import { IMarketIndex, IShortCompanyInfo, IStockSymbol, STOCK_BG_COLOR_CONIG } from "../../common/model/Model"
import { appStore } from "../../common/store/AppStore"
import _ from 'lodash'
export interface ICompanyRatingDetail {
    ticker: string;
    floorCode: string;
    companyName: string;
    companyNameEn: string;
    icbName: string;
    icbNameEn: string;
    parentIcbName: string;
    parentIcbNameEn: string;
    ratingIndustryRate: string;
    ratingIndustrySizeRate: string;
    ratingGrowthRate: string;
    ratingBasicRate: string;
    previousRatingBasicRate: string;
    ratingChange: number;
    changeRatingBasicRate: number;
    pointCalcBasicPoint: number;
    pointCalcIndustryPoint: number;
    pointCalcMarketPoint: number;
    pointCalcBasicPlusPoint: number;
    pointCalcGrowthPoint: number;
    pointCalcShortTermPoint: number;
    pointCalcShortTermPointGroup: number;
    pointCalcMidTermPoint: number;
    pointCalcMidTermPointGroup: number;
    pointCalcLongTermPoint: number;
    pointCalcLongTermPointGroup: number;
    pointCalcGrowthPlusPoint: number;
    marketCap: number;
    totalShare: number;
    avgQtty10: number;
    beta: number;
    currentForeignRoom: number;
    roe: number;
    roa: number;
    pe: number;
    pb: number;
    dividendYield: number;
    chartData?: any;
}
export interface ICompanyRatingDataChart {
    stockSymbol: string;
    basicPointChartData: any[][];
    growthPointChartData: any[][];
    profitChartDataVnIndex: any[][];
    profitChartDataStockSymbol: any[][];

}
interface ISameStock {
    ticker: string;
    yearRating: number;
    quarterRating: number;
    pointCalcIndustryPoint: number;
    pointCalcGrowthPoint: number;
    pointCalcBasicPoint: number;
    ratingBasicRate: string;
    floorCode: string;
    previousYearReport: number;
    previousLengthReport: number;
    previousRevenue: number;
    previousProfit: number;
    yearReport: number;
    lengthReport: number;
    revenue: number;
    revenueChange: number;
    profit: number;
    profitChange: number;
    roe: number;
    marketCap: number;
    pe: number;
}
class StockRankingStore {
    @observable symbol: string = ""
    @observable companyRatingDetail?: ICompanyRatingDetail
    @observable companyRatingDataChart?: ICompanyRatingDataChart
    @observable keySearch: string = ""
    @observable showAutoCompleteForm: boolean = false;
    @observable listShortCompany: IShortCompanyInfo[] = []
    @observable showSearchForm: boolean = false
    @observable sameStocksInfo: ISameStock[] = []
    @observable stockSymbolInfo?: IStockSymbol = {
        "stockSymbol": "AAA",
        "value":"AAA",
        "basicPrice": 0,
        "ceilingPrice": 0,
        "floorPrice": 0,
        "matchPrice": 0,
        "matchQtty": 0,
        "matchValue": 0,
        "totalTradingQtty": 0,
        "totalTradingValue": 0,
        "percentChange": [
        ]
    }
    async getCompanyRatingDetail() {
        let result = await getRequest(Constants.API_DASHBOARD_URL + 'GetCompanyRatingDetail?stockSymbol=' + this.symbol)
        if (result.status < HttpStatusCode.CODE_300) {
            this.companyRatingDetail = result.body
        }
    }
    async getCompanyRatingChartData() {
        let result = await getRequest(Constants.API_DASHBOARD_URL + 'CompanyRating?code=' + this.symbol, true)
        if (result.status < HttpStatusCode.CODE_300) {
            this.companyRatingDataChart = result.body
        }
    }
    async getSameStock() {
        let result = await getRequest(Constants.API_DASHBOARD_URL + 'GetCompanyRatingSameIcbWithPaging?stockSymbol=' + this.symbol + '&pageSize=29', true)
        if (result.status < HttpStatusCode.CODE_300) {
            this.sameStocksInfo = result.body
        }
    }
    handleChageInputSearch(key: string) {
        stockRankingStore.keySearch = key
        if (key) {
            stockRankingStore.showAutoCompleteForm = true
            stockRankingStore.listShortCompany.map((item) => {
                if (item.value.toUpperCase().indexOf(key.toUpperCase()) > -1) {
                    item.isHide = false
                }
                else item.isHide = true
            })
            let t = _.cloneDeep(stockRankingStore.listShortCompany)
            t.sort((a, b) => {
                if (a.value.toLowerCase().indexOf(key.toLowerCase()) > b.value.toLowerCase().indexOf(key.toLowerCase())) {
                    return 1;
                } else if (a.value.toLowerCase().indexOf(key.toLowerCase()) < b.value.toLowerCase().indexOf(key.toLowerCase())) {
                    return -1;
                } else {
                    if (a.value > b.value)
                        return 1;
                    else
                        return -1;
                }
            });
            stockRankingStore.listShortCompany = t
        }
        else {
            stockRankingStore.showAutoCompleteForm = false
        }
    }
    regisListenStockSymbolUpdate() {
        appStore.regisShortStockInfo()
    }
    getListShortCompany() {
        this.listShortCompany = _.cloneDeep(appStore.listShortCompany)
    }
    async updateMarketOverViewInfo(data: IMarketIndex[]) {
        if (this.stockSymbolInfo) {
            let newInfo = data.find((index) => (index.stockSymbol === this.symbol))
            if (newInfo && this.stockSymbolInfo) {
                let t = _.cloneDeep(newInfo)
                if (this.stockSymbolInfo && this.stockSymbolInfo.matchPrice && t.matchPrice && this.stockSymbolInfo.matchPrice < t.matchPrice) {
                    t.colorUpdate = STOCK_BG_COLOR_CONIG.UP
                }
                if (this.stockSymbolInfo && this.stockSymbolInfo.matchPrice && t.matchPrice && this.stockSymbolInfo.matchPrice > t.matchPrice) {
                    t.colorUpdate = STOCK_BG_COLOR_CONIG.DOWN
                }
                if (this.stockSymbolInfo) {
                    if (this.stockSymbolInfo.matchPrice !== t.matchPrice) {
                        this.stockSymbolInfo = t
                        setTimeout(() => {
                            if (this.stockSymbolInfo)
                                this.stockSymbolInfo.colorUpdate = ""
                        }, Constants.EFFECT_UPDATE_TIME)
                    }
                }
                else {
                    this.stockSymbolInfo = t
                    setTimeout(() => {
                        if (this.stockSymbolInfo)
                            this.stockSymbolInfo.colorUpdate = ""
                    }, Constants.EFFECT_UPDATE_TIME)
                }
            }
        }
    }
    async handleSymbolSelect(symbol) {
        stockRankingStore.showAutoCompleteForm = false
        stockRankingStore.showSearchForm = false
        stockRankingStore.symbol = symbol
        stockRankingStore.keySearch = ""
        stockRankingStore.getCompanyRatingDetail()
        stockRankingStore.getCompanyRatingChartData()
        stockRankingStore.regisListenStockSymbolUpdate()
        stockRankingStore.getSameStock()
    }
}
export const stockRankingStore = new StockRankingStore()